import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cardStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse, { HTMLReactParserOptions } from "html-react-parser";
import Icon from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";

interface InfoCardModel {
    fields: {
        iconTitle: string;
        textSize: string;
        primaryBackground: string;
        primaryIcon: string;
        secondaryIcon: string;
    };
}

const enum fields {
    socialCards = "socialCards",
    iconTitle = "iconTitle",
    textSize="textSize",
    primaryBackground="primaryBackground",
    infoCardTitle = "infoCardTitle",
    primarySectionWidth = "primarySectionWidth",
    titleColor = "titleColor",
    primaryIcon = "primaryIcon",
    secondaryIcon = "secondaryIcon"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.socialCards]: InfoCardModel[];
        infoCardTitle: string;
        titleColor: string;
        primarySectionWidth: GridWidths;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { socialCards, infoCardTitle, titleColor, primarySectionWidth },
    } = ownProps;
    const mappedInfoCards = [];
    for (const card of socialCards) {
        mappedInfoCards.push(card.fields);
    }
    
    return {
        infoCardTitle,
        titleColor,
        primarySectionWidth,
        mappedInfoCards,
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface IInfoCardsStyles {
    container?: GridContainerProps;
    infoCard?: GridItemProps;
    customflyImgWrapper?: InjectableCss;
    customDescriptionText?: TypographyPresentationProps;
    customFlyTitle?: TypographyPresentationProps;
    infocardcontainer?: InjectableCss;
    infocardWraper?: InjectableCss;
    buttonStyle?: LinkPresentationProps;
    infoCardTitle?: InjectableCss;
    sectionWrapper?: InjectableCss;
    textWrapper?: InjectableCss;
    footerSectionWrapper?: InjectableCss;
    footerBtn?: ButtonPresentationProps;
    textIconWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sectionTitleWrapper?: InjectableCss;
    infoCardWrapper?: InjectableCss;
    iconTitle?: InjectableCss;
    iconSubTitle?: InjectableCss;
    iconTitleGrid?: GridItemProps;
    secondaryIcon?: InjectableCss;
}

export const infoCardsStyles: IInfoCardsStyles = {
    infoCardTitle: {
        css: css`
            [data-test-selector="infoCardTitle"] {
                font-size: 1.7rem;
                font-weight: 500;
                margin: 20px 0px;
                margin-bottom: 20px;
                font-family: "Barlow-Regular";
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 0px;
                            margin: 0px;
                            margin-bottom: 25px;
                            margin-top: 20px;
                        `,
                        css`
                            padding-left: 0px;
                            margin: 0px;
                            margin-bottom: 25px;
                            margin-top: 20px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    infocardcontainer: {
        css: css`
            max-width: 1300px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 720px !important;
                        `,
                        css`
                            max-width: 960px !important;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    container: {
        gap: 38,
        css: css`
            align-items: center;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 0px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 0px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    iconTitleGrid:{
        css:css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding-bottom: 0px;   
                        `,
                        css`
                          padding-bottom: 0px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
    infoCard: {
        css: css`
            display: flex;
            flex-direction: column;
            min-height: 200px;
            padding: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding-top: 0px;   
                        `,
                        css`
                          padding-top: 0px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        
            [data-test-selector="infoCardWrapper"] {
                height: 100%;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                gap: 18px;
                padding: 20px;
                width: 100%;
                position: relative;
                padding-bottom: 25px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 15px;
                                padding-bottom: 25px;
                            `,
                            css`
                                padding: 15px;
                                padding-bottom: 25px;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            }
        `,
    },
    infocardWraper: {
        css: css`
            border-bottom: 5px solid ${getColor("primary.main")};
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            box-shadow: 1px 7px 11px 0px rgb(0 0 0 / 13%);
        `,
    },
    customflyImgWrapper: {
        css: css`
            box-sizing: border-box;
            width: 100%;
            height: 180px;
            overflow: hidden;
            div[class^="LazyImageStyle"] {
                width: 100%;
                height: auto;
            }
            img {
                height: 180px;
                width: 100%;
                object-fit: cover;
            }
        `,
    },
    customFlyTitle: {
        variant: "p",
        css: css`
            font-size: 1.6rem;
            letter-spacing: 0;
            margin: 0px;
            font-weight: 600;
            text-transform: uppercase;
            font-family: 'Barlow-Regular';
            line-height: 33px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          font-size: 1.2rem !important;
                        `,
                        css`
                          font-size: 1.2rem !important;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    customDescriptionText: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 0.9rem;
            font-weight: 600;
            letter-spacing: 0;
            line-height: inherit;
            font-family: 'Barlow-Regular';
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        `,
    },
    buttonStyle: {
        css: css`
            span {
                background-color: transparent !important;
                color: ${getColor("primary.main")} !important;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 2px;
                line-height: normal;
                text-transform: uppercase;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    sectionWrapper:{
        css:css`
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            padding: 7px 15px;
        `
    },
    textWrapper:{
        css:css`
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        `
    },
    footerSectionWrapper:{
        css:css`
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 4rem;
        `
    },
    footerBtn:{
        css:css`
            padding: 10px 15px;
            text-transform: uppercase;
            font-family: 'Barlow-Regular';
        `
    },
    textIconWrapper:{
        css:css`
            display: flex;
            gap: 15px;
            width: 100%;
        `
    },
    imageWrapper:{
        css:css`
            width: 58px;
            min-width: 58px;
            img{
            width: 58px;
            max-width: 58px;
            }
        `
    },
    sectionTitleWrapper:{
        css:css`
            width: 100%;
            display: flex;
            justify-content: left;
            align-items: center;
            height: 100%;
            padding: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding: 15px;
                        `,
                        css`
                          padding: 15px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
    infoCardWrapper:{
        css:css`
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            gap: 18px;
            padding: 20px;
            width: 100%;
            position: relative;
            padding-bottom: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                            padding-bottom: 25px;
                        `,
                        css`
                            padding: 15px;
                            padding-bottom: 25px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
    iconTitle:{
        css:css`
            font-size: 1rem;
            font-weight: 600;
            font-family: 'Barlow-Regular';
        `
    },
    iconSubTitle:{
        css:css`
        font-size: 0.9rem; 
        `
    },
    secondaryIcon:{
        css:css`
            width: 30px;
            position: absolute;
            right: 10px;
            bottom: 10px;
            height: 30px;
        `
    },
};

const styles = infoCardsStyles;

const DescriptionWrapper = styled.div`
    height: 100%;
`;

const InfoCards: React.FC<Props> = ({ id, infoCardTitle, 
        titleColor,
        primarySectionWidth,
        mappedInfoCards,
         }) => {

    return (
        <>
            <StyledWrapper >
                <StyledWrapper {...styles.infocardcontainer}>
                    <GridContainer>
                        <GridItem width={12} {...styles.infoCardTitle}>
                            {infoCardTitle ? (
                                <Typography 
                                as="h2"
                                data-test-selector="infoCardTitle"
                                style={{ color: titleColor? titleColor : "#000000" }}
                                >{infoCardTitle}</Typography>
                            ) : null}
                        </GridItem>
                    </GridContainer>
                    {mappedInfoCards?.length > 0 ? (
                        <GridContainer {...styles.container}>
                            {mappedInfoCards?.map((card, index) => (        
                                <GridItem 
                                    key={index}
                                    width= {[12, 12, primarySectionWidth, primarySectionWidth, primarySectionWidth]}
                                    {...styles.infoCard} 
                                >
                                    <StyledWrapper
                                        data-test-selector="infoCardWrapper"
                                        style={{backgroundColor : card.primaryBackground ? card.primaryBackground : "#ffffff"}}
                                        >
                                        <StyledWrapper key={index} {...styles.textIconWrapper}>
                                            {card.primaryIcon && 
                                                <StyledWrapper {...styles.imageWrapper}>
                                                    <LazyImage src={card.primaryIcon} altText={card.iconTitle} />
                                                </StyledWrapper>
                                            }
                                            <StyledWrapper {...styles.textWrapper}>
                                                {card?.iconTitle && <Typography {...styles.iconTitle} >{card.iconTitle}</Typography>}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                            

                                        {card.secondaryIcon && <>
                                                <LazyImage src={card.secondaryIcon} {...styles.secondaryIcon}/>
                                            </>
                                        }
                                        
                                    </StyledWrapper>
                                </GridItem>
                            ))}
                        </GridContainer>
                    ) : null}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const membersList: WidgetModule = {
    component: connect(mapStateToProps)(InfoCards),
    definition: {
        group: "Basic",
        icon: "presentation-screen",
        fieldDefinitions: [
            {
                name: fields.socialCards,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.iconTitle;
                },
                defaultValue: [],
                fieldType: "Translatable",

                sortOrder: 2,
                fieldDefinitions: [
                    {
                        name: fields.iconTitle,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 0,
                    },
                    {
                        name: fields.textSize,
                        displayName: "Title Font size",
                        editorTemplate: "TextField",
                        defaultValue: "1.6",
                        sortOrder: 4,
                    },
                    {
                        name: fields.primaryBackground,
                        displayName: "Primary Background",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "white",
                        sortOrder: 4,
                    },
                    {
                        name: "primaryIcon",
                        displayName: "Primary Icon",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        sortOrder: 6
                    },
                    {
                        name: "secondaryIcon",
                        displayName: "Secondary Icon",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        sortOrder: 7
                    },
                    
                ],
            },
            {
                name: fields.infoCardTitle,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
            {
                fieldType: "Translatable",
                name: fields.titleColor,
                displayName: "Title color",
                editorTemplate: "ColorPickerField",
                defaultValue: "black",
                sortOrder: 1,
            },
            {
                name: fields.primarySectionWidth,
                displayName: "Primary section width",
                editorTemplate: "TextField",
                defaultValue: "3",
                sortOrder: 2,
                fieldType: "Translatable",
            },

        ],
    },
};

export default membersList;
